import { RelatedService } from 'modules/related-services';
import { analyticsUtils } from 'utils/analytics-utils';
import { VariantAxisProduct } from 'modules/collections';

type GAProductInfo = {
  productName: string;
  productId: string;
  productPrice: number;
  productPrevPrice: null;
  productBelong: 'LeroyMerlin';
  komplektyId: string;
};

const getAddToCartInfo = (product: VariantAxisProduct) => ({
  komplektyId: product.productId,
  products: product.products.map(({ displayedName, productId, pricePerSingle, quantity }) => ({
    productName: displayedName,
    productId,
    productPrice: pricePerSingle,
    productQuantity: quantity,
  })),
});

export const getProductGAInfo = (product: VariantAxisProduct): GAProductInfo => ({
  productName: product.displayedName,
  productId: product.productId,
  productPrice: product.price,
  productPrevPrice: null,
  productBelong: 'LeroyMerlin',
  komplektyId: product.productId,
});

export const getServiceGAInfo = (
  product: VariantAxisProduct,
  service: RelatedService,
  position: number,
  elementBlock: string
) => ({
  elementType: 'product',
  elementBlock: `${elementBlock} / services`,
  komplektyId: product.productId,
  productName: service.title,
  productId: service.categoryId,
  productPrice: service.price,
  productPosition: position + 1,
});

export const previewClickGAEvent = (
  product: VariantAxisProduct,
  mediaLink: string,
  elementBlock: string
) => {
  const productInfo = getProductGAInfo(product);

  analyticsUtils.sendEvent('GA:clickButton', {
    elementType: 'button',
    elementBlock,
    elementName: 'mediaPhoto',
    mediaLink,
    ...productInfo,
  });
};

export const addToCartGAEvent = (
  product: VariantAxisProduct,
  elementBlock: string,
  elementName?: string
) => {
  analyticsUtils.sendEvent('GA:addToCart', {
    elementBlock,
    elementType: 'button',
    ...(elementName ? { elementName } : {}),
    ...getAddToCartInfo(product),
  });
};

export const serviceClickGAEvent = (
  product: VariantAxisProduct,
  service: RelatedService,
  position: number,
  elementBlock: string
) => {
  analyticsUtils.sendEvent('GA:clickProduct', {
    elementName: 'productButtonLink',
    productQuantity: 1,
    productBelong: 'LeroyMerlinServices',
    ...getServiceGAInfo(product, service, position, elementBlock),
  });
};

export const serviceShowGAEvent = (
  product: VariantAxisProduct,
  service: RelatedService,
  position: number,
  elementBlock: string
) => {
  analyticsUtils.sendEvent('GA:impressions', {
    ...getServiceGAInfo(product, service, position, elementBlock),
  });
};

export const showMoreClickGAEvent = (
  buttonName: string,
  elementName: string,
  productId: string,
  elementBlock: string
) => {
  analyticsUtils.sendEvent('GA:clickButton', {
    elementType: 'button',
    elementBlock,
    elementName,
    elementText: buttonName,
    komplektyId: productId,
  });
};
